export default __webpack_public_path__ + "static/media/nz.f7d2cb13.svg";